import store from '@/store'

export default [
  {
    path: '/suppliers',
    name: 'supplier',
    meta: { requiresAuth: true },
    component: () => import('@/pages/supplier/index.vue'),
    beforeEnter: async (to, from, next) => {
      next()
    }
  },
  {
    path: '/suppliers/create',
    name: 'supplier-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/supplier/create.vue'),
    beforeEnter: async (to, from, next) => {
      next()
    }
  },
  {
    path: '/suppliers/:id',
    name: 'supplier-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/supplier/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('supplier/find', to.params.id)
      next()
    }
  }
]
